export enum StreamType {
  VIDEO = 'video',
  AUDIO = 'audio',
  SUBTITLE = 'subtitle',
}

export type StreamTypeValue = StreamType | 'video' | 'audio' | 'subtitle';
